<app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">

  <p-toolbar>
    <ng-template #start>
      <div class="flex gap-2 toolbar-menu">
        <p-selectButton [options]="resultsView" visible="true" class="resultsViewButton"
          [(ngModel)]="selectedResultsView" (onChange)="resultsViewToggle($event)"
          [allowEmpty]="false">
        </p-selectButton>

        @if (selectedResultsView !== 'temperaturePoints') {
          <p-selectButton [options]="depthView"
            [(ngModel)]="selectedDepthView" (onChange)="depthViewToggle($event)"
            [allowEmpty]="false">
          </p-selectButton>
        }
        
        <p-selectButton [options]="resultsDisplay" [(ngModel)]="selectedResultDisplay"
          (onChange)="onSelectedResultDisplayUpdated($event)" [allowEmpty]="false">
        </p-selectButton>
      </div>
    </ng-template>
  </p-toolbar>

  @if (selectedResultDisplay === 'plot') {
    <app-xy-line-plot [plotData]="plot.data" [xAxisTitle]="xAxisTitle" [yAxisTitle]="yAxisTitle" [plotName]="plotName"
      [downloadPlotName]="downloadPlotName" [plotTitle]="'Load P&T Profiles'"
      [xyLinePlotStore]="pressTempStore"
      >
    </app-xy-line-plot>
  }

  @if (selectedResultDisplay === 'grid') {
    <app-single-load-grid
      [rowData]="gridResults"
      [columnDefinitions]="gridColumnDefinitions"
      tableName="Load P&T Profiles"
      gridName="Load P&T Profiles"
    >
    </app-single-load-grid>
  }

  <p-dialog [draggable]="false" [visible]="errorMsg != null" [closable]="false" appendTo="self">
    <i class="pi pi-exclamation-circle"></i>
    <label>{{ errorMsg }}</label>
    <br />
    <br />
  </p-dialog>

</app-tool-loader>